/**
 * @generated SignedSource<<1e961066fd39273adccca506270f8c62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PixKeyType = "CNPJ" | "CPF" | "EMAIL" | "PHONE" | "RANDOM" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPDetails_charge$data = {
  readonly companyBankAccount: {
    readonly pixKeyRecipient: {
      readonly pixKey: string | null | undefined;
      readonly pixKeyType: PixKeyType | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly identifier: string | null | undefined;
  readonly " $fragmentType": "PaymentActiveITPDetails_charge";
};
export type PaymentActiveITPDetails_charge$key = {
  readonly " $data"?: PaymentActiveITPDetails_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPDetails_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveITPDetails_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyBankAccount",
      "kind": "LinkedField",
      "name": "companyBankAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPixKey",
          "kind": "LinkedField",
          "name": "pixKeyRecipient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pixKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pixKeyType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "5b48ceab16dec220579b842280690aee";

export default node;
